/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";

/** @module core/modules/reg-exp-utils/check-one */
import { normalize } from './normalize.js';
/** @typedef {(string|RegExp|Array<(string|RegExp)>)} checkOneRawExpType */

/**
 * @description Checks input against all items in rawExp and returns a truthy value if at least one match is found. Returns false for an invalid rawExp.
 * @param {string} str - Input string.
 * @param {checkOneRawExpType} rawExp - Expression to check.
 * @returns {boolean} Result.
 */

function checkOne(str, rawExp) {
  var _context,
      _this = this,
      _context2;

  return _someInstanceProperty(_context = normalize(rawExp)).call(_context, _bindInstanceProperty(_context2 = function _context2(elem) {
    _newArrowCheck(this, _this);

    if (elem instanceof RegExp) {
      return elem.test(str);
    } else {
      return false;
    }
  }).call(_context2, this));
}

export { checkOne };